// extracted by mini-css-extract-plugin
export var incommOfferBanner = "IncommOfferBanner-module--incommOfferBanner--640f7";
export var incommOfferBannerDescription = "IncommOfferBanner-module--incommOfferBannerDescription--9ff45";
export var incommOfferBannerImage = "IncommOfferBanner-module--incommOfferBannerImage--9e324";
export var incommOfferBannerTitle = "IncommOfferBanner-module--incommOfferBannerTitle--89b21";